export default "__VITE_ASSET__cQeYAlis__"